module.exports = __webpack_public_path__ + "static/media/PM129.415e6acb.png";